var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCaretDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75593 5.12713C5.35716 5.58759 4.64284 5.58759 4.24407 5.12713L1.23682 1.65465C0.675944 1.00701 1.136 0 1.99275 0L8.00725 0C8.864 0 9.32406 1.00701 8.76318 1.65465L5.75593 5.12713Z",
    fill: "#E1E1E1"
  })));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaretDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/caret-down.3695edc8.svg";
export { ForwardRef as ReactComponent };